import { Tag } from 'antd'
import { FC } from 'react'
import { OrderStatus } from '../../../../../types/api/form-order'

interface FormOrderOrderStatusCellProps {
    orderStatus: OrderStatus
}

const orderStatusColor: Record<OrderStatus, string> = {
    Создан: 'default',
    'В сборке': 'blue',
    'В пути': 'geekblue',
    'Готов к выдаче': 'cyan',
    Завершен: 'green',
}

const FormOrderOrderStatusCell: FC<FormOrderOrderStatusCellProps> = ({ orderStatus }) => {
    return <Tag color={orderStatusColor[orderStatus]} style={{ margin: 0 }}>
        {orderStatus}
    </Tag>
}

export default FormOrderOrderStatusCell